<div class="container mt-9">
  <div class="disclaimer flex flex-column">
    <div class="card">
      <div class="card-header">
        <mat-icon class="location" fontIcon="my_location"></mat-icon>

        <h4 class="body-large-bold">
          {{ 'DISCLAIMER.HOW_IT_HELPS_TITLE' | translate }}
        </h4>
      </div>

      <p class="body-medium">
        {{ 'DISCLAIMER.HOW_IT_HELPS_TEXT' | translate }}
      </p>
    </div>

    <div class="card">
      <div class="card-header">
        <mat-icon class="library material-symbols-outlined" fontIcon="local_library"></mat-icon>

        <h4 class="body-large-bold">
          {{ 'DISCLAIMER.WHAT_YOU_CAN_EXPLORE_TITLE' | translate }}
        </h4>
      </div>

      <p class="body-medium">
        {{ 'DISCLAIMER.WHAT_YOU_CAN_EXPLORE_TEXT' | translate }}
      </p>
    </div>

    <div class="card">
      <div class="card-header">
        <mat-icon class="food material-symbols-outlined" fontIcon="emoji_food_beverage"></mat-icon>

        <h4 class="body-large-bold">
          {{ 'DISCLAIMER.COMING_NEXT_TITLE' | translate }}
        </h4>
      </div>

      <p class="body-medium">
        {{ 'DISCLAIMER.COMING_NEXT_TEXT' | translate }}
      </p>
    </div>
  </div>
</div>
